import React from 'react';
import { useTranslation } from 'react-i18next';

import SelfServiceIcon from './SelfServiceIcon';

const BookingOrderFromSelfServiceBadge: React.FC<{
  className?: string;
}> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`h-6 px-2 inline-flex text-xs font-semibold rounded-full uppercase bg-gray-100 text-gray-800 ${
        className || ''
      }`}>
      <div className="flex items-center">
        <SelfServiceIcon className="text-blue-lime pr-1" />
        {t('components.BookingOrderFromSelfServiceBadge.fromSelfService')}
      </div>
    </div>
  );
};

export default BookingOrderFromSelfServiceBadge;
